import { Skeleton, SkeletonBadge, SkeletonCard, SkeletonRegion } from 'shared/components/ui/Skeleton';

// Espelha o card da lista de torneios: esporte, nome, data/arena e valor da inscrição.
export function TournamentCardSkeleton() {
  return (
    <SkeletonCard>
      <SkeletonBadge className="w-24" />
      <Skeleton className="mt-3 h-5 w-44" />
      <Skeleton className="mt-2 h-3 w-52" />
      <Skeleton className="mt-3 h-3.5 w-24" />
    </SkeletonCard>
  );
}

// Página inteira do detalhe: cabeçalho, inscrição/prazo, categorias e card da dupla.
export function TournamentDetailSkeleton() {
  return (
    <SkeletonRegion label="Carregando torneio...">
      <section className="mx-auto max-w-2xl pb-28">
        <div className="border-b border-border/60 bg-surface px-4 py-8">
          <Skeleton className="h-3 w-40" />
          <Skeleton className="mt-3 h-7 w-56" />
          <Skeleton className="mt-2 h-3 w-48" />
        </div>
        <div className="px-4 py-6">
          <div className="grid grid-cols-2 gap-3">
            {[0, 1].map((index) => (
              <div key={index} className="rounded-xl border border-border/70 p-4">
                <Skeleton className="h-2.5 w-16" />
                <Skeleton className="mt-2 h-4 w-24" />
              </div>
            ))}
          </div>
          <Skeleton className="mt-6 h-3 w-24" />
          <div className="mt-3 flex flex-col gap-2">
            {[0, 1, 2].map((index) => (
              <div key={index} className="rounded-xl border border-border/70 bg-surface p-4">
                <Skeleton className="h-4 w-28" />
                <Skeleton className="mt-2 h-3 w-36" />
              </div>
            ))}
          </div>
          <SkeletonCard className="mt-6 p-4">
            <Skeleton className="h-3 w-20" />
            <div className="mt-3 flex items-center gap-3">
              <Skeleton className="h-8 w-8 rounded-full" />
              <Skeleton className="h-3.5 w-40" />
            </div>
          </SkeletonCard>
        </div>
      </section>
    </SkeletonRegion>
  );
}
